import request from '@/utils/request'

/**
 * 获取系统配置列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含系统配置列表的Promise对象
 */
export function getSystemInfoList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.listSystemInfo',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新系统配置
 * @param {Object} data 更新数据
 * @returns {Promise} 包含更新结果的Promise对象
 */
export function updateSystemInfo(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.updateSystemInfo',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}